import { CardType, FundingSource, FundingSourceType } from '@melio/platform-api';

export const isCreditCardFundingSource = (fs?: FundingSource) =>
  fs?.type === FundingSourceType.Card && fs.details.type === CardType.Credit;
